export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const ClOSE_NOTIFICATION = "ClOSE_NOTIFICATION";
